import React, { useMemo } from 'react';
import _get from 'lodash/get';
import _upperFirst from 'lodash/upperFirst';

import { UiKit } from 'components';
import { FeeConfig } from '../components';
import { useSegment } from 'utils/hooks';
import { usePaymentProcessingFee } from './context';
import { FEE_TYPE } from './stubs';

export default function Form({ isDisabled = false }) {
  const { track } = useSegment();
  const {
    data,
    errors,
    isError,
    isProcessing,
    onChange,
    onReload
  } = usePaymentProcessingFee();

  const handleToggle = value => {
    track('FTU Wizard Fee Toggled', {
      fee_type: 'payment_processing_fee',
      is_active: value
    });
    onChange({ fees_enabled: value });
  };

  const feeType = _get(data, 'fee_type', FEE_TYPE.fixed);
  const isPercentType = feeType === 'percentage';

  const { options, optionsMap } = useMemo(() => {
    return Object.values(FEE_TYPE).reduce(
      (acc, type) => {
        const option = {
          label: `${_upperFirst(type)} Fee`,
          value: type
        };
        acc.options.push(option);
        acc.optionsMap[type] = option;
        return acc;
      },
      { options: [], optionsMap: {} }
    );
  }, []);

  const selectedType = optionsMap[feeType];

  return (
    <FeeConfig
      title="Payment Processing Fee"
      subtitle="Fee applied when refunding to the original payment method."
      isActive={data.fees_enabled}
      isError={isError}
      onReload={onReload}
      isDisabled={isDisabled}
      isProcessing={isProcessing}
      onToggle={handleToggle}
    >
      <UiKit.Flex direction="column" gap={16}>
        <UiKit.Grid gap="16" templateColumns="1fr 1fr">
          <UiKit.Select
            label="Fee Type"
            options={options}
            value={selectedType}
            onChange={o => onChange({ fee_type: _get(o, 'value') })}
            placeholder="Select an option"
            isDisabled={isDisabled}
            error={errors.fee_type}
          />
          <div />
        </UiKit.Grid>
        <UiKit.Grid gap="16" templateColumns={'1fr 1fr'}>
          <UiKit.Input
            type="number"
            min={0}
            maxDecimalPrecision={0}
            label={`${isPercentType ? 'Percentage' : 'Fixed'} Fee`}
            value={data.amount}
            onChange={value => onChange({ amount: value })}
            placeholder={`say, ${isPercentType ? '10%' : '$4'}`}
            disabled={isDisabled}
            error={errors.amount}
            icon={isPercentType ? '%' : '$'}
          />
          {isPercentType && (
            <UiKit.Input
              type="number"
              min={0}
              label="Maximum Fee"
              value={
                data.ceiling_amount === null || data.ceiling_amount === 'null'
                  ? ''
                  : data.ceiling_amount
              }
              onChange={value => onChange({ ceiling_amount: value })}
              placeholder="say, $4"
              disabled={isDisabled}
              error={errors.ceiling_amount}
              icon="$"
            />
          )}
        </UiKit.Grid>
      </UiKit.Flex>
    </FeeConfig>
  );
}
